import { trpc } from '@/shared/api';

export const usePortfolioDetailQuery = (id: string, options: { enabled?: boolean } = {}) =>
  trpc.portfolio.get.useQuery({ id }, { enabled: options.enabled ?? true, retry: false });
